import { useState } from "react";
import { Thumbs, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperType } from 'swiper';

import SwiperCore from 'swiper';

import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import './Swiper.scss';

export default function Slider({ urlImages } : { urlImages : string[]}) {

    const [thumbsSwiper, setThumbsSwiper] = useState<SwiperCore | null>(null);

    if (urlImages.length == 0)
        urlImages= ['/no_photo.svg']
    
    return (
        <div className="gameInfo_swiper-container">
            <Swiper
                modules={[Thumbs]}
                thumbs={{ swiper: thumbsSwiper }}
                allowTouchMove={true}
                grabCursor={true}
                speed={500}
            >
              {urlImages.map((src, index) => (
                <SwiperSlide key={index} className="swiper-slide-visible">
                  <img src={src} />
                  </SwiperSlide>
              ))}
            </Swiper>

            <Swiper
                modules={[Thumbs, Navigation]}
                onSwiper={(swiper: SwiperType) => setThumbsSwiper(swiper)}
                slidesPerView={4}
                navigation={true}
                keyboard={{ enabled: true }}
                breakpoints={{
                    1420: {
                        slidesPerView: 4,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    480: {
                        slidesPerView: 3,
                    },
                    320: {
                        slidesPerView: 2,
                    },
                    0: {
                        slidesPerView: 1,
                    }
                }}
            >
                {urlImages.map((src, index) => (
                    <SwiperSlide key={index} >
                        <img src={src}/>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}


